import * as React from 'react';
import { ReportEventView } from 'cb-model';
import {
  PageTitle,
  PaginatorAndListSettings,
  Search,
  Section,
  useCacheQuery,
  useCloneEntity,
  useQueryOptionsFromSearchParams,
} from 'gossamer-front-end';
import { ReportMenu } from './ReportMenu';

export const EventSearch = (): React.JSX.Element => {
  const [queryOptions, setQueryOptions] = useQueryOptionsFromSearchParams(ReportEventView);
  const LocalReportEventView = useCloneEntity(ReportEventView, (clone) => {
    clone.fields.event_id.listColumn = true;
  });
  const gCacheQueryItem = useCacheQuery(ReportEventView, queryOptions);
  return (
    <>
      <PageTitle title="Event Detail Report" />
      <ReportMenu />
      <Section>
        <p>Bookings and Attendance per Event</p>
        <PaginatorAndListSettings
          entity={LocalReportEventView}
          gCacheQuery={gCacheQueryItem}
          queryOptions={queryOptions}
          render={Search}
          setQueryOptions={setQueryOptions}
        />
      </Section>
    </>
  );
};
